import React, { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import Image from 'next/image';
import { Calendar } from '../ui/calendar';
import { cn } from '@/lib/utils';
import { format } from 'date-fns'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { FormControl } from '../ui/form';
import cal from '@/public/images/calendar-days.svg';
import chevron from '@/public/home-appointment-images/chevron-down.png'


const StepThree = ({ onPreviousStep, onSubmit, appointmentBooking, lang }) => {
    const { control, handleSubmit, formState: { errors } } = useFormContext();
    const [specialityApiData, setSpecialityApiData] = useState([]);
    const [doctorApiData, setDoctorApiData] = useState([]);
    const [locationApiData, setLocationApiData] = useState([]);

    const onSubmitForm = (data) => {
        onSubmit(data); // Pass the data to the parent component (MultiStepForm) for final submission
    };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/specialities?fields=specialityName&locale=${lang?lang:'en'}`);
                const data = await response.json();
                setSpecialityApiData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const fetchDatadoctors = async () => {
            try {
                const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/doctors?fields=doctors&locale=${lang?lang:'en'}`);
                const data = await response.json();
                setDoctorApiData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const fetchDataLocation = async () => {
            try {
                const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/locations?fields=locations&locale=${lang?lang:'en'}`);
                const data = await response.json();
                setLocationApiData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
        fetchDatadoctors();
        fetchDataLocation();
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmitForm)}>
            <Controller
                name="location"
                control={control}
                defaultValue=""
                rules={{
                    required: appointmentBooking.validation.loc,
                }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.loc}</Label>
                        <Select onValueChange={field.onChange} >
                            <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                <SelectTrigger className='text-primaryGreyText'>
                                    <SelectValue placeholder={appointmentBooking.loc} />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent className=' max-h-96 overflow-scroll'>
                                {locationApiData.data?.map((e, i) => (<SelectItem key={i} value={e.attributes.locationCity}>{e.attributes.locationCity}</SelectItem>))}
                            </SelectContent >
                        </Select>
                        {errors.location && <span className='text-xs text-primaryRed absolute'>{errors.location.message}</span>}
                    </div>
                )}
            />
            <Controller
                name="speciality"
                control={control}
                defaultValue=""
                rules={{
                    required: appointmentBooking.validation.spec,
                }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.spec}</Label>
                        <Select onValueChange={field.onChange} >
                            <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                <SelectTrigger className='text-primaryGreyText'>
                                    <SelectValue placeholder={appointmentBooking.spec} />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent className=' max-h-96 overflow-scroll'>
                                {specialityApiData.data?.map((e, i) => (<SelectItem key={i} value={e.attributes.specialityName}>{e.attributes.specialityName}</SelectItem>))}
                            </SelectContent>
                        </Select>
                        {errors.speciality && <span className='text-xs text-primaryRed absolute'>{errors.speciality.message}</span>}
                    </div>
                )}
            />
            <Controller
                name="doctor"
                control={control}
                defaultValue=""
                // rules={{
                //     required: 'doctors is required',
                // }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.doc}</Label>
                        <Select onValueChange={field.onChange} >
                            <Select onValueChange={field.onChange} >
                                <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                    <SelectTrigger className='text-primaryGreyText'>
                                        <SelectValue placeholder={appointmentBooking.doc} />
                                    </SelectTrigger>
                                </FormControl>
                                <SelectContent className=' max-h-96 overflow-scroll'>
                                    {doctorApiData.data?.map((e, i) => (<SelectItem key={i} value={e.attributes.doctorName}>{e.attributes.doctorName}</SelectItem>))}
                                </SelectContent>
                            </Select>

                        </Select>
                        {errors.doctor && <span className='text-xs text-primaryRed absolute'>{errors.doctor.message}</span>}
                    </div>
                )}
            />

            <Controller
                name="date"
                control={control}
                defaultValue={null} // Set default date value to null
                rules={{
                    required: appointmentBooking.validation.date,
                }}

                render={({ field }) => (
                    <div className='mb-3 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.date}</Label>
                        <Popover >
                            <PopoverTrigger asChild className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                <Button
                                    variant={"outline"}
                                    className={cn(
                                        "text-left font-normal",
                                        !field.value && "text-muted-foreground",
                                        'w-full'
                                    )}
                                >
                                    {field.value ? (
                                        format(field.value, "PPP")
                                    ) : (
                                            <span className='text-primaryGreyText'>MM/DD/YY</span>
                                    )}
                                    <Image src={cal} width={22} height={22} className="ml-auto h-4 w-4 opacity-60" alt='calender' />
                                    <Image src={chevron} alt='arrow' height={16} width={16} className='text-primaryBlack opacity-60' />
                                </Button>

                            </PopoverTrigger>
                            <PopoverContent>
                                <Calendar
                                    mode="single"
                                    selected={field.value}
                                    onSelect={field.onChange}
                                    // disabled={(date) =>
                                    //     date > new Date() || date < new Date("1900-01-01")
                                    // }
                                    disabled={(date) => date < today}
                                    initialFocus
                                />
                            </PopoverContent>
                            {errors.date && <span className='text-xs text-primaryRed absolute bottom-0 left-0 top-16'>{errors.date.message}</span>}
                        </Popover>
                    </div>
                )}
            />
            <div className='flex flex-row justify-between'>
                <Button onClick={onPreviousStep} variant='outline' className='mt-3 rounded-3xl w-40 text-primaryWhite bg-primaryBlue uppercase stepthree_prevbtn'>{appointmentBooking.prev}</Button>
                <Button type="submit" variant='outline' className='mt-3 rounded-3xl w-40 bg-primaryWhite text-primaryBlue ml-8 uppercase stepthree_nextbtn'>{appointmentBooking.button}</Button>

            </div>
        </form>
    );
};

export default StepThree;
